"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const mui_1 = require("tss-react/mui");
const Button_1 = __importDefault(require("@mui/material/Button"));
const Divider_1 = __importDefault(require("@mui/material/Divider"));
const ButtonBase_1 = __importDefault(require("@mui/material/ButtonBase"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
const CloudDownload_1 = __importDefault(require("@mui/icons-material/CloudDownload"));
const core_1 = require("companion-app-components/utils/core");
const QTip_1 = __importDefault(require("components/QuickenControls/QTip"));
const checknum_details_svg_1 = __importDefault(require("assets/checknum_details.svg"));
const styles_1 = require("./styles");
const styledComponents_1 = require("./styledComponents");
const log = (0, core_1.getLogger)('components/QuickenControls/QImageGallery/index.tsx');
const useStyle = (0, mui_1.makeStyles)()(styles_1.styles);
const QImageGallery = ({ images: propImages, action, closeFn, selectedImages }) => {
    const [currIndex, setCurrIndex] = (0, react_1.useState)(0);
    const [images, setImages] = (0, react_1.useState)(propImages.map((obj) => (Object.assign(Object.assign({}, obj), { selected: 'off' }))));
    const [validImages, setValidImages] = (0, react_1.useState)([]);
    const [errorImages, setErrorImages] = (0, react_1.useState)([]);
    const { classes } = useStyle();
    (0, react_1.useEffect)(() => {
        if (propImages) {
            const newImages = propImages.map((obj) => (Object.assign(Object.assign({}, obj), { selected: 'off' })));
            setImages(newImages);
            setCurrIndex(Math.min(currIndex, newImages.length));
        }
    }, [propImages, currIndex]);
    const markValid = (0, react_1.useCallback)((url) => {
        setValidImages((prev) => [...prev, url]);
    }, []);
    const markError = (0, react_1.useCallback)((url) => {
        setErrorImages((prev) => [...prev, url]);
    }, []);
    const numSelected = (0, react_1.useCallback)(() => images.filter((i) => i.selected === 'on').length, [images]);
    const processSelected = (0, react_1.useCallback)(() => {
        if (selectedImages) {
            const ids = images.filter((i) => i.selected === 'on').map((i) => i.id);
            selectedImages(ids);
        }
    }, [images, selectedImages]);
    const clickThumb = (index) => setCurrIndex(index);
    const clickPic = (url) => window.open(url, '_blank');
    const processKey = (e) => {
        log.log('KEY');
        if (e.key === 'Escape' && closeFn) {
            e.preventDefault();
            closeFn();
        }
    };
    const getField = () => {
        const imageDivs = [];
        const thumbs = [];
        if (images.length > 0) {
            images.forEach((i, index) => {
                const isValidImage = validImages.includes(i.url);
                const isErrorImage = errorImages.includes(i.url);
                const extension = i.name.slice(i.name.lastIndexOf('.'));
                const isUnavailable = i.url === 'unavailable';
                const errText = isUnavailable
                    ? 'This document is no longer available'
                    : `This document type (${extension}) cannot be displayed, click to download`;
                if (currIndex === index) {
                    imageDivs.push(<div key={`img-${i.url}${i.id}`}>
              <ButtonBase_1.default onClick={() => clickPic(i.url)} style={{ display: 'block', margin: 'auto' }} disabled={isUnavailable}>
                <div>
                  {isValidImage && (<styledComponents_1.ImageDiv src={isValidImage ? i.url : checknum_details_svg_1.default} className="show"/>)}
                  {isErrorImage && !isUnavailable && <CloudDownload_1.default className={classes.cloudIcon}/>}
                  {!isValidImage && !isErrorImage && (<CircularProgress_1.default size={25} className={classes.loadingCircle2}/>)}
                  <Typography_1.default className={(0, classnames_1.default)(isValidImage ? classes.hide : classes.show, classes.mainImageText)} variant="h5">
                    {isErrorImage || isUnavailable ? errText : 'Loading...'}
                  </Typography_1.default>
                </div>
              </ButtonBase_1.default>
            </div>);
                }
                thumbs.push(<styledComponents_1.ThumbDiv key={`img-thumb${i.url}`} className={(0, classnames_1.default)(currIndex === index ? 'selected' : '')}>
            <QTip_1.default title={`${i.name}`}>
              <ButtonBase_1.default onClick={() => clickThumb(index)} className={classes.button}>
                <img alt="select item" onLoad={() => markValid(i.url)} onError={() => markError(i.url)} src={i.url} className={isValidImage ? classes.show : classes.hide}/>
                <Typography_1.default className={(0, classnames_1.default)(isValidImage ? classes.hide : classes.show)}>
                  {extension}
                </Typography_1.default>
              </ButtonBase_1.default>
            </QTip_1.default>
          </styledComponents_1.ThumbDiv>);
            });
        }
        else {
            imageDivs.push(<div key="thumbkey" className={classes.loadingBlock}>
          <CircularProgress_1.default size={52} className={classes.loadingCircle}/>
          <Typography_1.default>Retrieving attachments...</Typography_1.default>
        </div>);
        }
        return (<div>
        {images.length > 0 && <styledComponents_1.SubTitle>Click image to open full screen in a separate tab</styledComponents_1.SubTitle>}
        <styledComponents_1.ViewPort>{imageDivs}</styledComponents_1.ViewPort>
        <Divider_1.default />
        <div style={{ display: 'flex' }}>
          <styledComponents_1.Thumbs>{thumbs}</styledComponents_1.Thumbs>
          {numSelected() > 0 && (<Button_1.default color="primary" onClick={processSelected}>
              {action || 'Action'}
            </Button_1.default>)}
        </div>
        <styledComponents_1.HiddenInput autoFocus onKeyDown={processKey}></styledComponents_1.HiddenInput>
      </div>);
    };
    return getField();
};
exports.default = QImageGallery;
